import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import { Moment } from 'config/moment'
import { ERRORS } from 'consts'
import { useApiCall } from 'hooks'
import { snackbar } from 'components'
import { formatDashboardNumber } from 'features/Main/NewDashboard/utils/formatDashboardNumber'

import { getStores } from './api'
import { DefaultTable } from '../../components'
import { GetStoresResponse, ParametersDownload, Stores } from './types'

const useStyles = makeStyles({
  title: {
    color: 'black',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
  },
  divider: {
    backgroundColor: 'black',
  },
})

const columns = [
  {
    title: 'ID',
    render: (rowData: Stores) => (rowData.store_id !== null ? rowData.store_id : ''),
  },
  { title: 'Título', render: (rowData: Stores) => rowData.store.name },
  {
    title: 'Cantidad',
    render: (rowData: Stores) => formatDashboardNumber(rowData.count_store),
  },
]

interface propsUsersStatus {
  startDate: Moment
  endDate: Moment
  storeIds?: number[]
  storeId?: number // Deprecated: use storeIds instead, kept for backward compatibility
  trigger?: number
  // eslint-disable-next-line react/require-default-props
  onLoaded?: () => void
  // eslint-disable-next-line react/require-default-props
  isParentLoading?: boolean
}

const StoresTopFive: React.FC<propsUsersStatus> = ({
  startDate,
  endDate,
  storeIds,
  storeId,
  trigger = 0,
  onLoaded,
  isParentLoading,
}) => {
  // Convert storeId to storeIds array for backward compatibility
  const finalStoreIds = storeIds || (storeId !== undefined ? [storeId] : undefined)
  const [data, setData] = useState<Stores[] | []>([])
  const [requestUsersTags, isLoading] = useApiCall<ParametersDownload, GetStoresResponse>(() =>
    getStores({
      startDate,
      endDate,
      ...(finalStoreIds && finalStoreIds.length > 0 && { storeIds: finalStoreIds.join(',') }),
    }),
  )

  useEffect(() => {
    if (trigger === undefined || trigger > 0) {
      requestUsersTags({
        startDate,
        endDate,
        ...(finalStoreIds && finalStoreIds.length > 0 && { storeIds: finalStoreIds.join(',') }),
      })
        .then(resp => {
          setData(resp.data)
        })
        .catch(() => {
          setData([])
          snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
        })
        .finally(() => {
          if (onLoaded) {
            onLoaded()
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endDate, startDate, finalStoreIds, trigger])

  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.title}>Registro de visitas por locales</Typography>
      </Grid>
      <Grid item xs={12}>
        <DefaultTable
          title="Registro de visitas por locales"
          columns={columns}
          data={data}
          isLoading={isLoading || !!isParentLoading}
          options={{ pageSize: 5, toolbar: false }}
        />
      </Grid>
    </>
  )
}

StoresTopFive.defaultProps = {
  storeIds: undefined,
  storeId: undefined,
  trigger: 0,
}

export { StoresTopFive }
